<ul class="breadcrumb breadcrumb-page">
  <li><a href="#">{{'app.Home' | translate}}</a></li>
  <li class="active">{{'pageHeader.hcps' | translate}}</li>
</ul>

<div class="page-header">
  <div class="row">
    <h1 class="col-xs-12 col-sm-4 text-center text-left-sm"><img [src]="logo" class="img-icon" />&nbsp;&nbsp;{{'pageHeader.hcps' | translate}}</h1>
  </div>
</div>

<div class="panel panel-default widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">{{'app.searchTitle' | translate}}</span>
  </div>

  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="row">
        <div class="col-sm-6">
          <input type="text"
                 name="name"
                 [(ngModel)]="search.searchText"
                 placeholder="{{'app.SEarch' |translate}}"
                 #name="ngModel"
                 autocomplete="off"
                 class="form-control" />
        </div>
        <div class="col-sm-3 margin-top-10 cursor-pointer" (click)="openFilterModal()">
          <span class="margin-right-7 filter-span">{{'app.Filter' | translate}}</span>
          <i class="fa fa-filter" aria-hidden="true"></i>
        </div>
      </div>
    </div>
  </div>
</div>

<crm-add-hcp *ngIf="reviewMode" [reviewMode]="true" [isEditRequest]="true" [editRequestId]="selectedEditRequestId" (closeEvent)="closeReview($event)" [hcpId]="selectedHcpId"></crm-add-hcp>

<div class="panel panel-success widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">{{'app.searchResult' | translate}}</span>
  </div>
  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="row padding-sm-vr">
        <div class="col-sm-12 text-right">
          <button type="button" class="btn btn-labeled btn-success" (click)="approveAllRequests()">{{'Approve All' | translate}}</button>&nbsp;
          <button type="button" class="btn btn-labeled btn-danger" (click)="rejectAllAddRequest()">{{'Reject All' | translate}}</button>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <p-table #dt [value]="hcps" [responsive]="true" sortMode="multiple" [paginator]="true" [rows]="pageSize" [totalRecords]="totalItems"
                   [lazy]="true" (onLazyLoad)="pageChanged($event)">
            <ng-template pTemplate="header">
              <tr>
                <!--<th width="7%">#</th>-->
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" width={{col.width}} style="text-align:center">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th width="10%" style="text-align:center" class="table-edit">Confirm</th>
                <th width="10%" style="text-align:center" class="table-edit">Reject</th>
                <th width="10%" style="text-align:center" class="table-edit">Review</th>
                <th width="10%" style="text-align:center" class="table-edit">{{'View Changes' | translate}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-hco>
              <tr *ngIf="hcps.length>0 && displayMode==2">

                <td>{{ hco.fullName }}</td>
                <td *ngIf="showEnglishName">{{ hco.englishName }}</td>
                <td>{{ hco.specialityName }}</td>
                <td>{{ hco.email  }}</td>
                <td>{{ hco.phone }}</td>
                <td *ngIf="!hco.hcos || hco.hcos.length==0"></td>
                <td *ngIf="hco.hcos&&hco.hcos.length>0"><a href="javascript:;" (click)="showHcos(hco.hcos)">HCOs</a></td>
                <td>{{ hco.createdByName }}</td>
                <td>{{ hco.lastModificationDate | date :'dd/MM/yyyy'}}</td>
                <td><a href="javascript:;" (click)="cofirmHcp(hco)"><i class="fa fa-check  fa-lg font-size-20"></i></a></td>
                <td><a href="javascript:;" (click)="rejectAddRequest(hco)"><i class="fa fa-times  fa-lg font-size-20"></i></a></td>
                <td><a href="javascript:;" (click)="gotoReview(hco.id, hco.editRequestId)"><i class="fa fa-comments  fa-lg font-size-20"></i></a></td>
                <td><a href="javascript:;" (click)="diffModal.show(hco.editRequestId)"><i class="fa fa-eye fa-lg font-size-20"></i></a></td>

              </tr>
              <tr *ngIf="hcps.length==0 && displayMode==2">
                <td colspan="6">{{'app.NoDataFound' | translate}}</td>
              </tr>
              <tr *ngIf="displayMode==1">
                <td colspan="6">
                  <div class="row col-sm-12 padding-sm-hr">
                    <div class="container text-center">
                      <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p>{{'app.Loading' | translate}}</p>
                    </div>
                  </div>
                </td>
              </tr>
              <tr *ngIf="displayMode==3">
                <td colspan="6">
                  <div class="alert alert-danger alert-dark">
                    <button type="button" class="close" data-dismiss="alert">×</button>
                    {{'app.ServerError' |translate}}.
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>

      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-sm-8">
  </div>
  <div class="col-sm-2 cursor-pointer left-15">

  </div>
  <div class="col-sm-2 cursor-pointer left-7" (click)="downloadCSV()">
    <span class="margin-right-7 edit-profile-span">{{'app.ExportSheet' | translate}}</span>
    <i class="fa fa-download" aria-hidden="true"></i>
  </div>
</div>

<div class="modal fade" bsModal #filterModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="panel padding-2">
      <div>
        <h1 class="filter-title">{{'app.Filter' | translate}}</h1>
      </div>
      <div class="row panel-body padding-sm-hr padding-top-0 padding-bottom-0">
        <div class="row">
          <div class="col-sm-6">
            <label class="control-label">{{'app.name' | translate}} </label>
            <input type="text"
                   name="name"
                   [(ngModel)]="search.searchText"
                   placeholder="{{'app.name' |translate}}"
                   #name="ngModel"
                   autocomplete="off"
                   class="form-control" />
          </div>
          <div class="col-sm-6">
            <label class="control-label">{{'reports.users' | translate}} </label>
            <span class="ui-fluid">
              <p-dropdown [options]="users"
                          name="visitAssistants" #visitAssistants="ngModel"
                          styleClass="wid100"
                          placeholder="User"
                          emptyFilterMessage="No results found"
                          showClear="true"
                          [(ngModel)]="search.user"
                          [virtualScroll]="true" itemSize="10"
                          [filter]="true" optionLabel="fullName"></p-dropdown>

            </span>
          </div>

          <div class="col-sm-6">
            <label class="control-label">{{'pageHeader.DateFrom' | translate}} </label>
            <div class="input-group date">
              <input type="text"
                     name="startDate"
                     #startDate="ngModel"
                     [(ngModel)]="search.startDate"
                     required="required"
                     #dpYMD="bsDatepicker"
                     bsDatepicker
                     [bsConfig]="{dateInputFormat: 'YYYY-MM-DD' }" class="form-control" autocomplete="off">
              <span class="input-group-btn date-label">
                <button class="btn date-btn" (click)="dpYMD.toggle()" type="button"><i class="fa fa-calendar"></i></button>
              </span>
            </div>
          </div>

          <div class="col-sm-6">
            <label class="control-label">{{'pageHeader.DateTo' | translate}}</label>
            <div class="input-group date">
              <input type="text"
                     name="endDate"
                     #endDate="ngModel"
                     [(ngModel)]="search.endDate"
                     required="required"
                     #dpYMD1="bsDatepicker"
                     bsDatepicker
                     [bsConfig]="{dateInputFormat: 'YYYY-MM-DD' }" class="form-control" autocomplete="off">
              <span class="input-group-btn date-label">
                <button class="btn date-btn" (click)="dpYMD1.toggle()" type="button"><i class="fa fa-calendar"></i></button>
              </span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <label class="control-label">{{'pageHeader.specialities' | translate}} </label>
            <span class="ui-fluid">
              <p-dropdown [options]="specialities"
                          placeholder="Select Speciality"
                          #brickId="ngModel"
                          emptyFilterMessage="No results found"
                          showClear="true"
                          styleClass="wid100"
                          name="brickId"
                          [(ngModel)]="search.speciality"
                          [filter]="true" optionLabel="name">


              </p-dropdown>
            </span>
          </div>
        </div>
        <div class="panel-footer margin-left-20 margin-top-20">
          <button type="button" (click)="hideFilterModal()" class="btn btn-cancel">{{'app.cancel' | translate}}</button>
          <button type="button" class="btn btn-save" (click)="searchFilterModal()">{{'app.Search' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>



<div class="modal fade" bsModal #rejectModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="panel padding-2">
      <div>
        <h1 class="delete-title">{{'hco.rejectFileQuestionTitle' | translate}}</h1>
        <p *ngIf="bulkRejectMode">{{'RejectAllConfirmation' | translate}} ({{hcps.length}})</p>
      </div>
      <div class="row panel-body padding-sm-hr padding-top-0 padding-bottom-0">

        <div class="panel-footer margin-left-20 margin-top-20">
          <button type="button" (click)="hideRejectModal()" class="btn btn-cancel">{{'app.cancel' | translate}}</button>
          <button type="button" class="btn btn-save" (click)="deleteHCP()">{{'app.reject' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" bsModal #hcosModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="panel padding-2">
      <div>
        <h1 class="filter-title">{{'Linked HCOs' | translate}}</h1>
      </div>

      <div class="row panel-body padding-sm-hr padding-top-0 padding-bottom-0">
        <div class="row">
          <p-table #dt [value]="selectedHcos" [responsive]="true">
            <ng-template pTemplate="header">
              <tr>
                <th>Hco Name</th>
                <th>Brick Name</th>
              </tr>

            </ng-template>
            <ng-template pTemplate="body" let-hco>
              <tr *ngIf="selectedHcos.length>0">

                <td>  {{ hco.name}}</td>
                <td>  {{ hco.brickName}}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        <div class="panel-footer margin-left-30 margin-top-20">
          <button type="button" (click)="hcosModal.hide()" class="btn btn-cancel">{{'app.cancel' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>

<crm-hcp-edit-request-diff #diffModal></crm-hcp-edit-request-diff>
